export const MXP_DIALOG_NAV_ATTR = 'data-mxp-dialog-nav';

export type MxpIframeHeightChangeHandler = (args: { height: number }) => void;
export type MxpIframeFavoriteAddedHandler = () => void;
export type MxpIframeReadyHandler = () => void;
export type MxpIframeNavigateHandler = (args: {
  allowedNavigateBack: boolean;
}) => void;
export type MxpIframeErrorHandler = (args: {
  type: 'jwtLoginError' | 'notFound';
  payload?: Record<string, string | undefined>;
}) => void;
export type MxpIframeShareHandler = (args: {
  url: string;
  title?: string;
  text?: string;
}) => void;
export type MxpIframeTitleChangeHandler = (args: {
  locationUri: string;
}) => void;

export type MxpIframeRef = {
  iframe: HTMLIFrameElement | null;
  postMessage: (message: MxpIframeOutgoingMessage) => void;
  ping: () => void;
  navigateBack: () => void;
  navigateTo: (moduleIdOrUrl: MxpModuleId | string) => void;
  getIframeUrl: () => URL;
};

export type MxpDialogData = {
  titles: MxpDialogTitleCollection;
  token: string | undefined;
};

export type MxpDialogTitleCollection = {
  [mxpPath: string]: string;
};

export enum MxpModuleId {
  ShoreExcursions = 'mxp365-shorex',
  Itinerary = 'mxp365-itinerary',
  PortInfo = 'mxp365-port-info',
  MyCalendar = 'mxp365-my-calendar',
  BoardActivities = 'mxp365-board-activities',
  Spa = 'mxp365-spa',
  Fitness = 'mxp365-fitness',
  HairDresser = 'mxp365-hair-dresser',
  MakeUp = 'mxp365-makeup',
  Restaurants = 'mxp365-restaurants',
  Packages = 'mxp365-packages',
  Venues = 'mxp365-venues',
  DeckPlan = 'mxp365-deck-plan',
  OpeningHours = 'mxp365-opening-hours',
  Announcements = 'mxp365-announcements',
  Weather = 'mxp365-weather',
  Favorites = 'mxp365-favorites',
  Chat = 'mxp365-chat',
  Messages = 'mxp365-messages',
}

export enum MxpIframeKeyCode {
  Enter = 13,
  Back = 8,
  ArrowUp = 38,
  ArrowDown = 40,
  ArrowLeft = 37,
  ArrowRight = 39,
}

export type MxpIframeIncomingMessage =
  | { action: 'favoriteAdded' }
  | { action: 'moduleReady' }
  | { action: 'share'; payload: { url: string; title?: string; text?: string } }
  | { action: 'jwtLoginError'; payload?: string }
  | { action: 'navigate'; payload: { allowedNavigationBack: boolean } }
  | { action: 'navigationChanged'; payload: { locationUri: string } };

export type MxpIframeOutgoingMessage =
  | { action: 'keyDown'; payload: { keyCode: MxpIframeKeyCode } }
  | { action: 'ping'; payload: { timePing: number } }
  | { action: 'navigateBack' }
  | { action: 'navigateTo'; payload: { mxpModule: string } };
